export default __webpack_public_path__ + "static/media/custombg1.557b19e8.png";